import { useState } from "react";
import Menu from "../../../components/menu/menu.jsx";
import Busca from "../../../components/busca/busca.jsx";
import ImportacaoDescontos from "../../../components/importacaodescontos/importacaodescontos.jsx";

function ImportarAssociados() {
  const [isMenuVisible, setIsMenuVisible] = useState(true);

  const toggleMenu = () => {
    setIsMenuVisible((current) => !current);
  };

  return (
    <div className={isMenuVisible ? "app-container" : "app-container-local"}>
      {isMenuVisible && (
        <div className="menu-visible col-auto col-md-3 col-xl-2 px-sm-2 px-0">
          <Menu page="utilitarios-importar-associados" />
        </div>
      )}

      <div className="row flex-nowrap">
        <div className="container-fluid">
          <div className="row flex-nowrap">
            <div className={`col py-3 me-4 ${isMenuVisible ? "" : "expand-content"}`}>
              <div className="mb-5">
                <Busca
                  texto="Importacao mensal de associados"
                  onToggleMenu={toggleMenu}
                />
              </div>

              <div className="bg-white p-4 rounded-4 border">
                <div className="d-flex justify-content-between mb-3">
                  <h2>Importar Planilha de Associados</h2>
                </div>

                <ImportacaoDescontos />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportarAssociados;
